const plugin = require('tailwindcss/plugin')

module.exports = plugin(function ({ addComponents, theme, e }) {
    const colors = theme('colors')
    let buttons = {}
    let configuredColors = []
    Object.entries(colors).map((item) => {
        if (typeof item[1] === 'string') {
            configuredColors.push(item[0])
        } else if (typeof item[1] === 'object') {
            Object.keys(item[1]).map((nested) => {
                configuredColors.push(`${item[0]}.${nested}`)
            })
        }
    })

    configuredColors.map((color) => {
        buttons[`.btn-${e(`${color}`)}`] = {
            display: 'inline-block',
            'background-color': theme(`colors.${color}`),
            'border-color': theme(`colors.${color}`),
            color: color === 'white' ? theme('colors.black') : theme('colors.white'),
            '&:hover': {
                color: color === 'white' ? theme('colors.black') : theme('colors.white'),
            },
        }
    })

    const buttonsUtility = {
        '.btn': {
            'font-weight': 600,
            'line-height': 1.4,
            'box-sizing': 'border-box',
            'font-size': theme('fontSize.13'),
            'font-family': theme('fontFamily.sans'),
            'background-color': theme('colors.white'),
            'text-transform': 'uppercase',
            'text-align': 'center',
            appearance: 'none',
            color: theme('colors.black'),
            border: `1px solid ${theme('colors.white')}`,
            padding: `${theme('spacing.3')} ${theme('spacing.5')}`,
        },
        ...buttons,
    }

    addComponents(buttonsUtility)
})
